import Button from '@components/Button';
import Input from '@components/Input';
import { CtaFormType } from '@data/types';
import classNames from 'classnames';
import React, { useState } from 'react';
import { submitSurveyByTaker } from 'utilities/api';

interface Props extends CtaFormType {
  as?: keyof JSX.IntrinsicElements;
  submitDefaultText?: string;
  submittingText?: string;
}

const CtaForm: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  submitDefaultText = 'Retrieve results',
  submittingText = 'Searching...',
  className,
  supplementaryHtmlContent,
}) => {
  const [submitText, setSubmitText] = useState<string>(submitDefaultText);
  const [message, setMessage] = useState<string>('');

  return (
    <Component
      className={classNames(
        'w-full bg-gradient-to-t from-2% from-blue to-red flex z-50 relative',
        className
      )}
    >
      <div className="p-4 xl:px-0 py-8 lg:py-16 w-full lg:w-1/2 max-w-innerGrid h-full flex gap-4 flex-col mx-auto justify-center">
        <div
          className="prose text-white prose-headings:text-white prose-h2:text-xl prose-h2:font-lighterNormal text-center"
          dangerouslySetInnerHTML={
            htmlContent ? { __html: htmlContent } : undefined
          }
        ></div>
        <form
          className="flex mt-4 flex-col w-full max-w-[500px] mx-auto"
          onSubmit={async (event) => {
            event.preventDefault();

            setSubmitText(submittingText);

            const formData = new FormData(event.target as HTMLFormElement);
            const emailAddress = formData.get('emailAddress');

            if (!emailAddress) {
              setMessage('Please enter an email address');
              setSubmitText(submitDefaultText);

              return;
            }

            const response = await submitSurveyByTaker(emailAddress);
            setSubmitText(submitDefaultText);

            if (response) {
              setMessage(
                'Thank you. An email has been sent; please check your inbox.'
              );
            } else {
              setMessage(
                'An error occurred; we were unable to send you an email. Please try again.'
              );
            }
          }}
        >
          <div className="flex gap-2 justify-center items-center flex-col md:flex-row ">
            <Input
              type="email"
              placeholder="Email Address"
              label="Email Address"
              hideLabel={true}
              className="!p-0 min-h-[48px] md:w-full max-w-[500px]"
            />
            <Button
              title={submitText}
              type="submit"
              className="!mt-0 w-full md:w-auto min-h-[48px] min-w-[195px]"
            />
          </div>

          {supplementaryHtmlContent && (
            <div
              className="mt-4 text-xs text-white text-left"
              dangerouslySetInnerHTML={{
                __html: supplementaryHtmlContent,
              }}
            ></div>
          )}

          {message && (
            <p className="mt-4 text-xs text-white text-left">{message}</p>
          )}
        </form>
      </div>
    </Component>
  );
};

export default CtaForm;
